import styled from 'styled-components';
import { theme } from '@/styles/theme';
import { Container, Section, Grid } from '@/components/ui/Container';
import { Card } from '@/components/ui/Card';
import { FadeInWhenVisible } from '@/components/animations/FadeInWhenVisible';

const PageHeader = styled(Section)`
  background: ${theme.colors.primary.navy};
  color: ${theme.colors.neutral.white};
  text-align: center;
  padding: ${theme.spacing[24]} 0 ${theme.spacing[16]};
`;

const PageTitle = styled.h1`
  color: ${theme.colors.neutral.white};
`;

const SponsorCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: ${theme.colors.neutral.white};
`;

const SponsorLogo = styled.div`
  font-size: ${theme.fontSizes['2xl']};
  color: ${theme.colors.neutral.gray};
  text-align: center;
`;

export const SponsorsPage = () => {
  return (
    <>
      <PageHeader>
        <Container>
          <PageTitle>Onze Sponsors</PageTitle>
        </Container>
      </PageHeader>

      <Section>
        <Container>
          <FadeInWhenVisible>
            <h2 style={{ marginBottom: theme.spacing[8], textAlign: 'center' }}>
              Met Dank Aan Onze Partners
            </h2>
          </FadeInWhenVisible>

          <Grid columns={4}>
            {[1, 2, 3, 4].map((sponsor, index) => (
              <FadeInWhenVisible key={sponsor} delay={index * 0.1}>
                <SponsorCard elevated interactive>
                  <SponsorLogo>[Sponsor Logo {sponsor}]</SponsorLogo>
                </SponsorCard>
              </FadeInWhenVisible>
            ))}
          </Grid>
        </Container>
      </Section>
    </>
  );
};
